import { render, staticRenderFns } from "./product-category-add-modal.vue?vue&type=template&id=0833b4e1&scoped=true&"
import script from "./product-category-add-modal.vue?vue&type=script&lang=js&"
export * from "./product-category-add-modal.vue?vue&type=script&lang=js&"
import style0 from "./product-category-add-modal.vue?vue&type=style&index=0&id=0833b4e1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0833b4e1",
  null
  
)

export default component.exports